module.exports = __webpack_public_path__ + "img/eh.7efa0aec.svg";